import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Divider} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {ADDRESS_BY_ACCOUNT,
    ALPHANUM_SPACE_HT} from "../../../../utils/constants/Constants";
import {Checkbox} from "primereact/checkbox";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditAddressView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    {props.messagesGrowl}
                    <Grid item xs={9}>
                        <TitlePage title={props.isNewAddress ?
                            'Administración \\ Facturación \\ Editar Institución \\ Agregar Dirección' :
                            'Administración \\ Facturación \\ Editar Institución \\ Editar Dirección'}/>
                    </Grid>
                    <Grid item xs={3} style={{textAlign: "right"}}>
                        <Button label="Regresar"
                                onClick={props.returnButton}
                                className="p-button-secondary"/> &nbsp;
                        <Button label="Guardar"
                                onClick={props.saveAddress}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Institución" isBold={true}/>
                        <SubtitleLabel header={props.institutionData.NomCorto} />
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Datos de Facturación" isBold={true}/>
                    </Grid>
                    {props.institutionData.IdTipo === ADDRESS_BY_ACCOUNT ?
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <SubtitleLabel header="Cuentas" isBold={true}/>
                                    <Dropdown
                                        name="accountObj"
                                        filterBy="Cuenta"
                                        options={props.accountsList}
                                        optionLabel="Cuenta"
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeValue}
                                        value={props.addressData.accountObj}
                                        disabled={!props.isNewAddress}/>
                                </Grid>
                                <Grid item xs={6}>
                                    <br/>
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                tabIndex={13} className={"secondary-text"}>
                                        <Checkbox name="sameAddress"
                                                  checked={props.addressData.sameAddress}
                                                  onChange={props.onChangeValue}/>&nbsp;
                                        Utilizar la misma dirección
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid> : ""
                    }
                    <Grid item xs={6}>
                        <SubtitleLabel header="Dirección" isBold={true}/>
                        <InputText name="Dir"
                                   keyfilter={ALPHANUM_SPACE_HT}
                                   maxLength={100}
                                   value={props.addressData.Dir}
                                   onChange={props.onChangeValue}/>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Colonia" isBold={true}/>
                        <InputText name="Colonia"
                                   keyfilter={ALPHANUM_SPACE_HT}
                                   maxLength={100}
                                   value={props.addressData.Colonia}
                                   onChange={props.onChangeValue}/>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Ciudad" isBold={true}/>
                        <InputText name="Cd"
                                   keyfilter={ALPHANUM_SPACE_HT}
                                   maxLength={100}
                                   value={props.addressData.Cd}
                                   onChange={props.onChangeValue}/>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Código Postal" isBold={true}/>
                        <InputText name="CP"
                                   keyfilter="pint"
                                   maxLength={10}
                                   value={props.addressData.CP}
                                   onChange={props.onChangeValue}/>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="RFC" isBold={true}/>
                        <InputText name="RFC"
                                   keyfilter="alphanum"
                                   maxLength={20}
                                   value={props.addressData.RFC}
                                   onChange={props.onChangeValue}/>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default EditAddressView;